import { Component } from '@angular/core';
import {LoadingSpinnerComponent} from './shared-module/components/loading-spinner/loading-spinner.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'RPM';

  constructor() {
  }
}
